/**
 * #194: `execute-actions` lehnt mit 409 ab, wenn der Plan inzwischen neu
 * erstellt wurde (`plan_veraltet`) oder an dieselbe Mail gerade schon eine
 * Antwort ging (`doppelte_antwort`). Beides muss die Karte gesondert
 * behandeln — als normaler Fehler stuende „[object Object]" im Toast und
 * niemand koennte bewusst „Trotzdem senden".
 */
/** #184: `grundlage_fehlt` — Projekt/Termin/Ansprechpartner ohne Kontakt bzw. Projekt; nichts lief. */
export type AblehnungsCode = "plan_veraltet" | "doppelte_antwort" | "grundlage_fehlt"

export class AusfuehrenAbgelehnt extends Error {
  readonly code: AblehnungsCode

  constructor(code: AblehnungsCode, message: string) {
    super(message)
    this.name = "AusfuehrenAbgelehnt"
    this.code = code
  }
}

/** Wirft `AusfuehrenAbgelehnt`, wenn die Antwort eine dieser Ablehnungen ist. */
export async function pruefeAusfuehrung(r: Response): Promise<void> {
  if (r.status !== 409) return
  let detail: unknown
  try {
    detail = ((await r.clone().json()) as { detail?: unknown })?.detail
  } catch {
    return
  }
  if (detail && typeof detail === "object") {
    const d = detail as { code?: unknown; message?: unknown }
    if (d.code === "plan_veraltet" || d.code === "doppelte_antwort" || d.code === "grundlage_fehlt") {
      throw new AusfuehrenAbgelehnt(d.code, String(d.message || ""))
    }
  }
}

/** URL fuer `execute-actions` mit den beiden Bestaetigungs-Schaltern. */
export function ausfuehrenUrl(emailId: number, opts?: { forceBook?: boolean; trotzDoppelt?: boolean }): string {
  const q = new URLSearchParams()
  if (opts?.forceBook) q.set("force_book", "true")
  if (opts?.trotzDoppelt) q.set("trotz_doppelt", "true")
  const s = q.toString()
  return `/api/v1/drafts/${emailId}/execute-actions${s ? `?${s}` : ""}`
}
